import { css } from '@emotion/react'
import styled from '@emotion/styled'
import Hamburger from '../../images/Hamburger';

// App Logos
import Logo from '../../images/novosalon-logo.svg'
import MobileLogo from '../../images/appstore.png'

import AccountMenu from './AccountMenu';
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import CreateNew from './Components/Create';
import { muiTheme } from '../../utils/theme';

// widgets
import Scheduled from './Components/Scheduled';
import Notifications from './Components/Notifications';
import ReadyForPickup from './Components/ReadyForPickup';
import ScheduledPickups from './Components/ScheduledPickups';

import useIsMobile from '../../hooks/useIsMobile';

const Container = styled.div`
  /* position: fixed; */
  background-color: ${props => props.theme.colors.white};
  grid-column: 1 / -1;
  grid-row: 1;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.border};
  /* box-shadow: ${muiTheme.shadows[1]}; */
  padding-right: 3rem;


  @media ${props => props.theme.breaks.down('md')} {
    grid-column: 1;
    padding-right: 1rem;
  }
`

const AppBarActions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-left: 2rem;

  @media ${props => props.theme.breaks.down('md')} {
    margin-left: 1rem;
  }
`

const ToggleIcon = styled(MenuOpenRoundedIcon)`
  display: block;
  cursor: pointer;
`
const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`
const LogoContainer = styled.div`
  height: 95%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .5s;
  margin-left: .5rem;
  overflow: hidden;

  img {
    width: 20rem;
    object-fit: contain;
  }

  @media ${props => props.theme.breaks.down('md')} {
    display: none;
    margin-left: 0;
    img {
      width: 4rem;
    }
  }
`

const VersionLabel = styled.div`
  font-size: 1rem;
  font-weight: 500;
  color: ${props => props.theme.colors.mildText};
  align-self: flex-end;
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  padding: .3rem 1rem;

  @media ${props => props.theme.breaks.down('md')} {
    display: none;
  }
`

const AppBar = ({toggleOpen, open = true}) => {

  const { isMobile } = useIsMobile();
  return (
    <Container>
      <AppBarActions>
        <ToggleIcon onClick={toggleOpen} />
        <LogoContainer open={open}>
          <img src={isMobile ? MobileLogo : Logo} alt="App Logo" />
        </LogoContainer>
       <VersionLabel>v3.0.8</VersionLabel> 
      </AppBarActions>
      <Actions>
        <CreateNew />
        <Notifications />
        {/* <ReadyForPickup /> */}
        <ScheduledPickups />
        <Scheduled />
        <AccountMenu />
      </Actions>
    </Container>
  )
}

export default AppBar;